import { useMemo } from "react";

import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import SignalEcommerceBucketFilter from "app/pages/sales-intelligence/sub-modules/signals/components/filters/SignalEcommerceBucketFilter/SignalEcommerceBucketFilter";
import SignalFiltersWrapper from "app/pages/sales-intelligence/sub-modules/signals/components/shared/SignalFiltersWrapper/SignalFiltersWrapper";
import { StyledDropdownLabel } from "app/pages/sales-intelligence/sub-modules/signals/components/shared/SignalsDropdownLabel/styles";
import useActiveFilterGenerator from "app/pages/sales-intelligence/sub-modules/signals/hooks/useActiveFilterGenerator";
import type EcommerceSignalFiltersViewProps from "app/pages/sales-intelligence/sub-modules/signals/models/view/ecommerce/EcommerceSignalFiltersViewProps";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

type Props = EcommerceSignalFiltersViewProps & {
    bucketOptions: readonly string[];
};

const EcommerceReachedFiltersView = (props: Props) => {
    const { filters, onFiltersChange, bucketOptions } = props;

    const bucketTransition = filters.bucketTransition;
    const metric = bucketTransition?.metric;

    const reachedAutoOpenSlice = useMemo(
        () => ({ bucket: bucketTransition?.bucket }) as Record<string, unknown>,
        [bucketTransition?.bucket],
    );

    const { currentActiveKey, setNextActiveKey } = useActiveFilterGenerator(reachedAutoOpenSlice);

    const handleBucketChange = (bucket: string): void => {
        if (typeof metric === "undefined") {
            return;
        }

        const key = currentActiveKey;
        const shouldAdvance =
            key !== null && key !== undefined && bucketTransition?.bucket === undefined;

        onFiltersChange({
            bucketTransition: {
                ...bucketTransition,
                metric,
                bucket,
            },
        });

        if (shouldAdvance) {
            setNextActiveKey();
        }
    };

    return (
        <SignalFiltersWrapper>
            <FlexRow
                alignItems="center"
                gap="8px"
            >
                <SignalEcommerceBucketFilter
                    options={bucketOptions}
                    selectedValue={bucketTransition?.bucket}
                    autoOpen={currentActiveKey === "bucket"}
                    onValueChange={handleBucketChange}
                />

                <I18n
                    data-automation="ecommerce-reached-over-last-month"
                    element={StyledDropdownLabel}
                    translatable={{ key: "si.signals.ecommerce.filters.reached-over-last-month" }}
                />
            </FlexRow>
        </SignalFiltersWrapper>
    );
};

export default EcommerceReachedFiltersView;
